export default __webpack_public_path__ + "photo-icon.deb65c61c1d6a844c09748703eddc34f.svg";